var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuidance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "58px",
    viewBox: "0 0 62 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Guidance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.00752382,0 C2.24194478,0 0,2.24553095 0,5.00003191 L0,44.9999681 C0,47.7614095 2.23452093,50 5.00752382,50 L54,50 L54,0 L5.00752382,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.0%",
    y: "-10.0%",
    width: "125.9%",
    height: "128.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 19.5,
    cy: 19.5,
    r: 19.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WEBAPP-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-like-me-mobile01",
    transform: "translate(-263.000000, -309.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guidance2",
    transform: "translate(267.000000, 311.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paper-shadow-z=\"1\"-copy-10"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0C9BED",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "002-talking",
    transform: "translate(8.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 9.375056)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6485696,12.6249435 L26.2987587,12.6249435 C23.951318,12.6249435 22.4050005,14.7085171 20.8447008,16.3554752 C20.6773078,16.5226811 20.4985911,16.548182 20.294864,16.3554752 L17.6682708,13.687981 C16.6048329,12.6079429 14.863158,12.6079429 13.7997201,13.687981 C12.7334266,14.7709193 12.7334266,16.5397817 13.7997201,17.6197198 L18.6368855,22.5323932 C19.7170627,23.6294319 21.4587377,23.5983308 22.5081934,22.5323932 L25.6316484,19.3603812 L25.6316484,28.1678921 C25.7237145,28.9276189 26.3153995,29.5286401 27.0635478,29.6249435 L39.5653435,29.6249435 C40.3133933,29.5286401 40.9050783,28.9276189 41,28.1678921 L41,17.0443995 C41,14.6150138 39.0406157,12.6249435 36.6485696,12.6249435 L36.6485696,12.6249435 Z",
    id: "Path",
    fill: "#48C0AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,28.1678835 L18,17.0443255 C18,14.6149255 16.0575287,12.6249435 13.6860327,12.6249435 L4.31113642,12.6249435 C1.93964045,12.6249435 0,14.6149255 0,17.0443255 L0,28.1678835 C0.0912714553,28.9276148 0.677849182,29.5286395 1.41944196,29.6249435 L16.5777272,29.6249435 C17.3193199,29.5286395 17.9058977,28.9276148 18,28.1678835 Z",
    id: "Path",
    fill: "#F4BC5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,8.68511131 C36,11.404349 33.7500588,13.6249435 30.9985169,13.6249435 C28.2499412,13.6249435 26,11.404349 26,8.68511131 L26,3.38997186 C26,1.86846836 27.2582978,0.624943515 28.7978766,0.624943515 L33.2021234,0.624943515 C34.7417022,0.624943515 36,1.86846836 36,3.38997186 L36,8.68511131 Z",
    id: "Path",
    fill: "#FAD9B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,3.38337643 L26,6.62494351 L29.4183313,4.97557126 C29.8794276,4.74978595 30.3258973,4.72971838 30.7926192,4.88693111 L36,6.62494351 L36,3.38337643 C36,1.86550218 34.7415999,0.624943515 33.2021234,0.624943515 L28.7978766,0.624943515 C27.2582978,0.624943515 26,1.86560302 26,3.38337643 L26,3.38337643 Z",
    id: "Path",
    fill: "#F4BC5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9998977,8.68511131 C13.9998977,11.4015187 11.7500818,13.6249435 8.99856804,13.6249435 C6.24991817,13.6249435 4,11.404349 4,8.68511131 L4,3.38997186 C4,1.86846836 5.2583872,0.624943515 6.79795025,0.624943515 L11.202152,0.624943515 C12.7388512,0.624943515 14,1.86846836 14,3.38997186 L14,8.68511131 L13.9998977,8.68511131 Z",
    id: "Path",
    fill: "#FAD9B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,3.51902355 L4,5.53435276 C5.40905,6.07412964 6.58622453,5.61824987 7.26476966,5.22246287 C7.78948122,4.91057298 7.87642173,4.85058602 8.39837166,5.32434549 C10.7990549,7.49858197 14,6.28995575 14,6.28995575 L14,3.51891775 C14,1.9264596 12.7388512,0.624943515 11.202152,0.624943515 L6.79795025,0.624943515 C5.2583872,0.625049312 4,1.9266712 4,3.51902355 L4,3.51902355 Z",
    id: "Path",
    fill: "#6B44FA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.30928313,0.0483012552 L15.8100863,0.0483012552 C16.5288213,0.0483012552 17.1169819,0.631179916 17.1169819,1.34346025 L17.1169819,9.82906067 C17.1169819,10.5414226 16.5288213,11.1242197 15.8100863,11.1242197 L12.9255964,11.1242197 L11.4972651,13.0068264 C11.1961867,13.4022929 10.9277932,13.409228 10.6221044,13.0068264 L9.19146787,11.1242197 L6.30928313,11.1242197 C5.58807831,11.1242197 5,10.5414226 5,9.82906067 L5,1.34346025 C5,0.631098326 5.58807831,0.0483012552 6.30928313,0.0483012552 Z",
    id: "Path",
    fill: "#47C1AD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4148434,0.0483012552 L39.6695582,0.0483012552 C40.37899,0.0483012552 40.9601526,0.62424477 40.9601526,1.32730544 L40.9601526,9.84529707 C40.9601526,10.5484393 40.37899,11.1243013 39.6695582,11.1243013 L28.9039297,11.1243013 L27.4755984,13.0069079 C27.2048996,13.3607636 26.9085141,13.4115941 26.6004378,13.0069079 L25.1698012,11.1243013 L21.4148434,11.1243013 C20.7054116,11.1243013 20.124249,10.5484393 20.124249,9.84529707 L20.124249,1.32730544 C20.124249,0.62416318 20.7054116,0.0483012552 21.4148434,0.0483012552 Z",
    id: "Path",
    fill: "#59BBAC",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.1598305,2.17411903 C23.8161471,2.17411903 23.5384768,1.87572615 23.5384768,1.50956898 C23.5384768,1.14341181 23.8162301,0.84758441 24.1598305,0.84758441 L37.3786463,0.84758441 C37.7223297,0.84758441 38,1.14350027 38,1.50956898 C38,1.87563769 37.7222467,2.17411903 37.3786463,2.17411903 L24.1598305,2.17411903 Z M24.1598305,7.83650661 C23.8161471,7.83650661 23.5384768,7.54059075 23.5384768,7.17443358 C23.5384768,6.80836487 23.8162301,6.50988352 24.1598305,6.50988352 L34.5282081,6.50988352 C34.8718915,6.50988352 35.1495618,6.80836487 35.1495618,7.17443358 C35.1495618,7.54059075 34.8718085,7.83650661 34.5282081,7.83650661 L24.1598305,7.83650661 Z M24.1598305,5.00526859 C23.8161471,5.00526859 23.5384768,4.70935273 23.5384768,4.34071853 C23.5384768,3.97456136 23.8162301,3.67873397 24.1598305,3.67873397 L37.3786463,3.67873397 C37.7223297,3.67873397 38,3.97464983 38,4.34071853 C38,4.70935273 37.7222467,5.00526859 37.3786463,5.00526859 L24.1598305,5.00526859 Z M9.93548136,4.27750625 C9.93548136,4.57146511 9.72675099,4.81115026 9.46861403,4.81115026 C9.21041468,4.81115026 9,4.57146511 9,4.27750625 C9,3.64923846 9.22457541,3.07936463 9.58533086,2.66655774 C9.94789539,2.25573994 10.4482619,2 11.0000312,2 C11.5534848,2 12.052167,2.25573994 12.4147315,2.66655774 C12.7772337,3.07936463 13,3.64923846 13,4.27750625 C13,4.90776313 12.7772337,5.47564787 12.4147315,5.88845476 C12.1582789,6.18042453 11.8328941,6.39389634 11.4686452,6.49256933 C11.4562936,6.77445158 11.251119,7 11.0000312,7 C10.7418318,7 10.5332262,6.76038588 10.5332262,6.46635599 L10.5332262,6.02335758 C10.5332262,5.72932769 10.7418942,5.48971357 11.0000312,5.48971357 C11.2952855,5.48971357 11.560534,5.35481075 11.7532946,5.13530064 C11.9460551,4.91579052 12.0645186,4.61373323 12.0645186,4.27743521 C12.0645186,3.94312628 11.9460551,3.6390799 11.7532946,3.42162992 C11.560534,3.2021198 11.2952855,3.06522789 11.0000312,3.06522789 C10.7064612,3.06522789 10.439466,3.20219084 10.2484521,3.42162992 C10.0556916,3.63915094 9.93548136,3.94319732 9.93548136,4.27750625 Z M11,8.38263715 C11,8.17102101 11.2230744,8 11.499033,8 C11.7750584,8 12,8.17102101 12,8.38263715 L12,8.61741398 C12,8.82903011 11.7750584,9 11.499033,9 C11.2230077,9 11,8.82897899 11,8.61741398 L11,8.38263715 Z",
    id: "Shape",
    fill: "#FEFEFD",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidance);
export default __webpack_public_path__ + "static/media/guidance.53a3524eb49d2c17c2cfb5b77507c1bd.svg";
export { ForwardRef as ReactComponent };